import * as Paginator from "react-bootstrap-table2-paginator";

import { Card, Col, Form, Row } from "react-bootstrap";
import { Field, Formik } from "formik";
import React, { useEffect, useState } from "react";
import ToolkitProvider, {
  CSVExport,
  Search,
} from "react-bootstrap-table2-toolkit";
import {
  faPlus,
  faSearch,
  faDownload,
} from "@fortawesome/free-solid-svg-icons";
import filterFactory, { textFilter } from "react-bootstrap-table2-filter";
import {
  getDealerDDFDispatchR,
  getDealerWiseDispatch,
} from "../../Service/AllReportAPI";
import {
  getDispatchEntryByDate,
  getDispatchList,
  getDispatchPdfDownload,
} from "../../Service/AllDispatchAPI";

import Axios from "../../utils/axiosInstance";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link } from "react-router-dom";
import Pagination from "react-bootstrap-table2-paginator";
import Select from "react-select";
import Table from "react-bootstrap-table-next";
import cellEditFactory from "react-bootstrap-table2-editor";
import fileSaver from "file-saver";
import { getDealerList } from "../master/AllUserDropDown";
import moment from "moment";
import swal from "sweetalert";
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";

//import * as Yup from "yup";

export default () => {
  const { SearchBar } = Search;
  const [entries, setEntries] = useState([]);
  const { ExportCSVButton } = CSVExport;
  const selectRow = {
    mode: "checkbox",
  };
  const [changeRowData, setChangeRowData] = useState({
    selectedRow: [],
    cellChange: "",
    columnChange: [],
  });
  const [dealerName, setDealerName] = useState([]);
  const [selectedDealer, setSelectedDealer] = useState("");
  const [isLoaded, setisLoaded] = useState(false);

  // --- pagination
  const [state, setState] = useState({});
  const [currentPage, setcurrentPage] = useState(0);
  const [pageCount, setPageCount] = useState(0);
  const [totaloffset, setTotaloffset] = useState(0);
  const [totalCount, setTotalCount] = useState(0);
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  let role = sessionStorage.getItem("role");

  useEffect(() => {
    // Function call to get Dispatch list
    getDispatch();
    getDealerDDFDispatchRList();
    // getDealersList();
    // eslint-disable-next-line
  }, []);

  // Function declaration of get customers list
  // const getDealersList = async () => {
  //   await getDealerList().then((result) => {
  //     setDealerName(result);
  //   });
  // };

  // const getDispatchListByFromDate = (e) => {
  //   setFromDate(e.target.value);
  //   console.log(fromDate);
  //   if (e.target.value > new Date().toISOString().split("T")[0]) {
  //     swal("Sorry", "Please select today or day before today", "warning");
  //   }
  // };

  // const getDispatchListByToDate = async (e) => {
  //   setToDate(e.target.value);
  //   console.log(toDate);
  //   if (e.target.value > new Date().toISOString().split("T")[0]) {
  //     swal("Sorry", "Please select today or day before today", "warning");
  //   }
  // };

  const handleFromDateChange = (date) => {
    setFromDate(date);
    // Clear the "To" date if it's before the selected "From" date
    if (toDate && date > toDate) {
      setToDate(null);
    }
  };

  const handleToDateChange = (date) => {
    if (date < fromDate) {
      swal('Invalid Date', 'The "To" date cannot be before the "From" date.', 'warning');
      setToDate(null); // Reset "To" date if invalid
    } else {
      setToDate(date);
    }
  };

  const getDealerDDFDispatchRList = async () => {
    let token = sessionStorage.getItem("token");
    let headers = { Authorization: `Bearer ${token}` };
    await getDealerDDFDispatchR(headers)
      .then((result) => {
        console.log("getDealerDDFDispatchRList result :-", result);
        let dealerDD = [];
        let tempDealerDDArray = result.data.map((obj) => {
          let dealer = obj.split(",");
          return {
            id: `${dealer[0]}`,
            value: `${dealer[1]}`,
            label: `${dealer[1]}`,
          };
        });
        dealerDD = tempDealerDDArray;
        setDealerName(dealerDD);
        console.log("getDealerDDFDDispatchRList", dealerDD);
      })
      .catch((error) => {
        console.log("getDealerDDFWorkOrderRList error :-", error);
      });
  };

  const handlePageChange = async (page) => {
    setEntries([]);
    const selectedPage = page - 1;
    console.log("selectedPage", selectedPage);
    if (selectedDealer === "") {
      const role = sessionStorage.getItem("role");
      const fkUserId = sessionStorage.getItem("pkUserId");
      const token = sessionStorage.getItem("token");
      const headers = { Authorization: `Bearer ${token}` };
      await getDispatchList(selectedPage, fkUserId, role, headers)
        .then((result) => {
          console.log("Get Pagination Dispatch Result", result);
          if (result?.data?.content?.length !== 0) {
            const data = result.data.content;
            const totalSize = result.data.pageable.offset;
            console.log("data", data);
            setEntries(data);
            setPageCount(result.data.totalPages);
            setTotaloffset(totalSize);
            entries.map((item, index) => (item.id = totalSize + index + 1));
          } else {
            swal("Sorry", "Data is not present", "warning");
          }
        })
        .catch((error) => console.error("Error", error));
    } else if (selectedDealer !== "") {
      await getDealerWiseDispatch(selectedPage, selectedDealer)
        .then((result) => {
          console.log("Get Pagination Dealer wise Dispatch Result", result);
          if (result?.data?.content?.length !== 0) {
            const data = result.data.content;
            const totalSize = result.data.pageable.offset;
            entries.map((item, index) => (item.id = totalSize + index + 1));
            console.log("totalSize", totalSize);
            console.log("data", data);
            setEntries(data);
            setTotaloffset(totalSize);
            setTotalCount(result.data.totalElements);
          } else {
            swal("Sorry", "Data is not present", "warning");
          }
        })
        .catch((error) => {
          console.log("Get Field Issue Error", error);
        });
    } else {
      swal("Failed", "Please select date", "error");
    }
  };

  const getDispatchByDate = async () => {
    try {
      setTimeout(async () => {
        if (fromDate !== "" && toDate !== "") {
          await getDispatchEntryByDate(
            currentPage,
            moment(fromDate).format("yyyy-MM-DD"),
            moment(toDate).format("yyyy-MM-DD")
          )
            .then((result) => {
              console.log("Get Production Entry Result", result);
              if (result?.data?.content?.length !== 0) {
                const data = result.data.content;
                setEntries(data);
                setPageCount(result.data.totalPages);
                setTotalCount(result.data.totalElements);
              } else {
                setEntries([]);
                setPageCount();
                setTotalCount();
                swal("Sorry", "Data is not present", "warning");
              }
              // console.log("setNoOfElements", noOfElements);
            })
            .catch((error) => {
              console.log("Get Production Error", error);
            });
        } else {
          swal("Failed", "Please select date", "error");
        }
      }, 200);
    } catch (error) {
      console.log(error);
      swal(
        "Failed",
        "Something went wrong please check your internet",
        "error"
      );
    }
  };

  const getDispatch = async () => {
    try {
      const role = sessionStorage.getItem("role");
      const fkUserId = sessionStorage.getItem("pkUserId");
      const token = sessionStorage.getItem("token");
      const headers = { Authorization: `Bearer ${token}` };
      await getDispatchList(currentPage, fkUserId, role, headers)
        .then((result) => {
          console.log("Get Dispatch Result", result);
          if (result?.data?.content?.length !== 0) {
            const data = result.data.content;
            setEntries(data);
            setPageCount(result.data.totalPages);
            setTotalCount(result.data.totalElements);
          } else {
            setEntries([]);
            setPageCount();
            setTotalCount();
          }
        })
        .catch((error) => {
          console.log("Get Dispatch Error", error);
        });
    } catch (error) {
      console.log(error);
      swal(
        "Failed",
        "Something went wrong please check your internet",
        "error"
      );
    }
  };
  
  const getDealerWiseDispatchPdf = async () => {
    if (fromDate !== "" && toDate !== "") {
      try {
        // setisLoaded(true);
        await getDispatchPdfDownload(
          moment(fromDate).format("yyyy-MM-DD"),
          moment(toDate).format("yyyy-MM-DD")
        );
        setisLoaded(false);
      } catch (error) {
        setisLoaded(false);
        console.log(error);
        swal(
          "Failed",
          "Failed to download pdf",
          "error"
        );
      }
    } else {
      try {
        let token = sessionStorage.getItem("token");
        let fileType = ["Pdf"];
        let role = sessionStorage.getItem("role");
        let fkUserId = sessionStorage.getItem("pkUserId");
  
        if (role === "customer") {
         
          let response = await Axios.get(
            `getDispatchDetailsListExcel?fileType=${fileType}&fkUserId=${fkUserId}&role=${role}`,
            {
              headers: { Authorization: `Bearer ${token}` },
              responseType: "arraybuffer",
            }
          );
          
          var blob = new Blob([response.data], { type: "application/pdf" });
          fileSaver.saveAs(blob, `customerDispatchreport.pdf`);
          setisLoaded(false);
        } else {
          setisLoaded(false);
          swal("Failed", "Please select a dealer name", "error");
        }
      } catch (error) {
        setisLoaded(false);
        console.log(error);
        swal(
          "Failed",
          " Failed to download pdf",
          "error"
        );
      }
    }
  };
  

  const getDealerWiseDispatchExcel = async () => {
    try {
      // setisLoaded(true);
  
      let token = sessionStorage.getItem("token");
      let fileType = ["Excel"];
      let role = sessionStorage.getItem("role");
      let fkUserId = sessionStorage.getItem("pkUserId");
  
    
      const formattedFromDate = moment(fromDate).format("yyyy-MM-DD");
      const formattedToDate = moment(toDate).format("yyyy-MM-DD");
  
      if (fromDate !== "" && toDate !== "") {
       
        let response = await Axios.get(
          `getDealerNameWiseDispatchReportPdf?fileType=${fileType}&fromDate=${formattedFromDate}&toDate=${formattedToDate}&fkUserId=${fkUserId}&role=${role}`,
          {
            headers: { Authorization: `Bearer ${token}` },
            responseType: "arraybuffer",
          }
        );
  
        let blob = new Blob([response.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        fileSaver.saveAs(blob, "customerDispatchreport.xlsx");
      } else {
        
        let response = await Axios.get(
          `getDealerNameWiseDispatchReportPdf?fileType=${fileType}&fkUserId=${fkUserId}&role=${role}`,
          {
            headers: { Authorization: `Bearer ${token}` },
            responseType: "arraybuffer",
          }
        );
  
        let blob = new Blob([response.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        fileSaver.saveAs(blob, "customerDispatchreport.xlsx");
      }
  
      setisLoaded(false);
    } catch (error) {
      setisLoaded(false);
      console.log("error :-", error);
      swal(
        "Failed",
        "failed to download excel",
        "error"
      );
    }
  };
  

  


const userRole= sessionStorage.getItem("role");
  // Adding srno column to list
  entries.map((item, index) => (item.id = totaloffset + index + 1));
  // Column heading of Dealer list
  const columns = [
   { dataField: "id", text: "Id" },
       {
         dataField: "status",
         text: "Dispatch WO Status",
         editable: false,
         headerAlign: "left",
         style: {
           textTransform: "capitalize",
         },
       },
       
       {
         dataField: "dispatchOrderNo",
         text: "Dispatch Wo No",
         editable: false,
         headerAlign: "left",
       },
      
       {
         dataField: "dispatchDate",
         text: "Dispatch Wo created on ",
         editable: false,
         align: "center",
         formatter: (cell) => {
           return <>{moment(cell).format("DD-MMM-YYYY")}</>;
         },
       },
       {
         dataField: "dispatchTime",
         text: "Dispatch Wo created Time",
         align: "center",
         formatter: (cell) => {
           return <>{moment(cell, "hh:mm A").format("hh:mm A")}</>;
         },
         editable: false,
       },
        {
             dataField: "closeDate",
             text: "Dispatch Wo closed on",
             editable: false,
             align: "center",
             formatter: (cell) => {
               const formattedDate = moment(cell);
               if (!formattedDate.isValid()) {
                 return 'Not Closed Yet  ';
               }
               return formattedDate.format("DD-MMM-YYYY");
             },
           }
           ,
       
       
           {
             dataField: "closeTime",
             text: "Dispatch Wo closed Time",
             align: "center",
             formatter: (cell) => {
               const formattedTime = moment(cell, "hh:mm A", true);
               if (!formattedTime.isValid()) {
                 return <>{'Not Closed Yet'}</>;
               }
               return <>{formattedTime.format("hh:mm A")}</>;
             },
       
             editable: false,
           },
       {
        dataField: "workOrderNo",
        text: "Production WO No",
        editable: false,
        headerAlign: "left",
      },
      {
        dataField: "generateUniqueDispenserNo",
        text: "Dispenser SR No",
        editable: false,
        headerAlign: "left",
      },
       {
        dataField: "modelName",
        text: "Dispenser Config",
        editable: false,
        headerAlign: "left",
      },
      {
        dataField: "cloureRemark",
        text: "Dispatch Closure remark",
        editable: false,
        headerAlign: "left",
        formatter: (cell, row) => {
  
          const text = cell || "";
  
          return (
            <div className="tooltip-container">
              <div className="truncated-text">{text}</div>
              {text.length > 20 && (
                <span className="tooltip-text">{row.cloureRemark || "No Remark"}</span>
              )}
            </div>
          );
        }
  
      },
      {
        dataField: "customerFullName",
        text: "Customer Name",
        editable: false,
        headerAlign: "left",
      },
       {
         dataField: "vehicleNo",
         text: "Vehicle No",
         editable: false,
         headerAlign: "left",
       },
       {
        dataField: "address",
        text: "Address",
        editable: false,
        style: { textTransform: "capitalize",},
        formatter: (cell, row) => (
          <div className="tooltip-container">
            <div className="truncated-text">{cell}</div>
            {cell.length > 20 && (
              <span className="tooltip-text">{row.address}</span>
            )}
          </div>
        )
      },
       {
         dataField: "driverName",
         text: "Driver Name",
         editable: false,
         headerAlign: "left",
       },
       {
         dataField: "driverContactNo",
         text: "Driver Contact No",
         editable: false,
         headerAlign: "left",
       },
       
      //  {
      //    dataField: "dealerName",
      //    text: "Dealer Name",
      //    editable: false,
      //    headerAlign: "left",
      //  },

      //  {
      //    dataField: "dispatchType",
      //    text: "Dispatch Type",
      //    editable: false,
      //    headerAlign: "left",
      //  },
   
      //  {
      //    dataField: "whoDidIt",
      //    text: "Dispatch Wo Created by",
      //    editable: false,
      //    headerAlign: "left",
      //  },

      ...(userRole === 'admin' ? [{
        dataField: "whoDidIt",
        text: "Dispatch Wo Created by",
        editable: false,
        headerAlign: "left",
      }] : []),
    
  ];

  // custom the pagination total
  const customTotal = (from, to, size) => (
    <div>
      Showing {totaloffset + from} to {totaloffset + to} of {size} entries
    </div>
  );

  // callback function when page was changing
  const customSizePerPage = (props) => {
    const { options, currentSizePerPage, onSizePerPageChange } = props;
    const onPageChange = (e) => {
      const page = e.target.value;
      onSizePerPageChange(page);
    };

    return (
      <>
        <Row>
          <Col xs="auto">
            <Form.Select
              value={currentSizePerPage}
              onChange={onPageChange}
              className="pe-5"
            >
              {options.map((o) => (
                <option key={o.page} value={o.page}>
                  {o.text}
                </option>
              ))}
            </Form.Select>
          </Col>
          <Col xs="auto" className="d-flex align-items-center">
            Entries per page
          </Col>
        </Row>
      </>
    );
  };

  return (
    <>
      {isLoaded ? (
        <div className="reportload"></div>
      ) : (
        <>
          {role === "customer" ? (
            <>
              <Row>
                <Col md={3} className="mb-3">
                <div className="form-group">
                <label>From Date</label>
                <DatePicker
                  selected={fromDate}
                  onChange={handleFromDateChange}
                  dateFormat="dd-MMM-yyyy"
                  maxDate={new Date()}
                  className="form-control"
                  placeholderText="DD-MMM-YYYY"
                  showYearDropdown
                  scrollableYearDropdown
                />
              </div>
                </Col>
                <Col md={3} className="mb-3">
                <div className="form-group">
                <label>To Date</label>
                <DatePicker
                  selected={toDate}
                  onChange={handleToDateChange}
                  dateFormat="dd-MMM-yyyy"
                  minDate={fromDate}
                  maxDate={new Date()}
                  className="form-control"
                  placeholderText="DD-MMM-YYYY"
                  showYearDropdown
                  scrollableYearDropdown
                />
              </div>
                </Col>
                <Col md={4} className="mb-3">
                  <button
                    className="btn btn-secondary mt-lg-4"
                    onClick={getDispatchByDate}
                  >
                    <FontAwesomeIcon icon={faSearch} className="me-2" />
                    <span>Search By Date</span>{" "}
                  </button>
                </Col>
              </Row>
            </>
          ) : (
            ""
          )}

          <Formik
            initialValues={{}}
            onSubmit={async (values) => {
              console.log(JSON.stringify(values, null, 2));
            }}
          >
            {(formik) => {
              return (
                <>
                  <Row>
                    {/* <Col md={6} className="mb-3">
                      <div className="form-group">
                        <label className="Label mb-1">Dealer Name</label>
                        <Select
                          id="dealerName"
                          placeholder="Select Dealer Name"
                          title="Select Dealer Name"
                          options={dealerName}
                          onChange={async (e) => {
                            formik.setFieldValue("dealerName", e.value);
                            setSelectedDealer(e.value);
                            await getDealerWiseDispatch(currentPage, e.value)
                              .then((result) => {
                                console.log(
                                  "Dealer wise dispatch Details",
                                  result.data
                                );
                                if (result?.data?.content?.length !== 0) {
                                  const data = result.data.content;
                                  setEntries(data);
                                  setPageCount(result.data.totalPages);
                                  setTotalCount(result.data.totalElements);
                                } else {
                                  setEntries([]);
                                  setPageCount();
                                  setTotalCount();
                                  swal(
                                    "Sorry",
                                    "Data is not present",
                                    "warning"
                                  );
                                }
                              })
                              .catch((error) => {
                                console.log("Dealer Error", error);
                              });
                          }}
                        />
                      </div>
                    </Col> */}
                  </Row>
                  {/* --- When you use any toolkit functionalities, you are supposed to render toolkit component and
  BootstrapTable as the children of ToolkitProvider --- */}
                  <ToolkitProvider
                    keyField="id"
                    search={true}
                    columns={columns}
                    data={entries}
                    exportCSV={{ onlyExportFiltered: true, exportAll: false }}
                  >
                    {({ baseProps, searchProps, csvProps }) => (
                      //render the Pagination component as a list with left and right arrows
                      <Paginator.PaginationProvider
                        pagination={Pagination({
                          custom: true,
                          disablePageTitle: true,
                          alwaysShowAllBtns: true,
                          totalSize: totalCount,
                          paginationTotalRenderer: customTotal,
                          onPageChange: handlePageChange,
                        })}
                      >
                        {({ paginationProps, paginationTableProps }) => (
                          <Card>
                            <div className="table-responsive py-2">
                              <Card.Header>
                                <Row>
                                  <Col xs={12} md={6} className="py-1">
                                    {/* <Paginator.SizePerPageDropdownStandalone
                                      {...paginationProps}
                                    /> */}
                                  </Col>
                                  <Col
                                    xs={12}
                                    md={6}
                                    className="d-flex justify-content-md-end py-1"
                                  >
                                    <button
                                      className="btn btn-secondary mx-2"
                                      onClick={getDealerWiseDispatchPdf}
                                    >
                                      <FontAwesomeIcon
                                        icon={faDownload}
                                        className="me-2"
                                      />
                                      <span>PDF</span>{" "}
                                    </button>
                                    <button
                                      className="btn btn-secondary"
                                      onClick={getDealerWiseDispatchExcel}
                                    >
                                      <FontAwesomeIcon
                                        icon={faDownload}
                                        className="me-2"
                                      />
                                      <span>Excel</span>
                                    </button>
                                  </Col>
                                </Row>
                              </Card.Header>
                              <Table
                                {...baseProps}
                                {...paginationTableProps}
                                bodyClasses="border-0"
                                rowClasses="border-bottom"
                                classes="table-flush dataTable-table"
                                // selectRow={selectRow}
                                filter={filterFactory()}
                                headerClasses="header-class"
                                hover
                                striped
                                remote={{ pagination: true }}
                                cellEdit={cellEditFactory({
                                  mode: "click",
                                  blurToSave: true,
                                  afterSaveCell: (
                                    oldValue,
                                    newValue,
                                    row,
                                    column
                                  ) => {
                                    const changeRowData = {
                                      selectedRow: row,
                                      cellChange: newValue,
                                      columnChange: column,
                                    };
                                    setChangeRowData(changeRowData);
                                  },
                                })}
                                wrapperClasses="table-responsive"
                              />
                              <Card.Footer>
                                <Row>
                                  <Col
                                    xs={12}
                                    md={6}
                                    className="d-flex align-items-center py-1"
                                  >
                                    {/* <Paginator.PaginationTotalStandalone
                              {...paginationProps}
                            /> */}
                                  </Col>
                                  <Col
                                    xs={12}
                                    md={6}
                                    className="d-flex justify-content-md-end align-items-center mb-0 py-1"
                                  >
                                    <Paginator.PaginationListStandalone
                                      {...paginationProps}
                                    />
                                  </Col>
                                </Row>
                              </Card.Footer>
                            </div>
                          </Card>
                        )}
                      </Paginator.PaginationProvider>
                    )}
                  </ToolkitProvider>
                </>
              );
            }}
          </Formik>
        </>
      )}
    </>
  );
};
// }};
